export default __webpack_public_path__ + "static/ioticono-5674ab0f61beb82d281cf01ac795860e.webp";